import http from '@utils/http';

/**
 * Billing module – aligned with backend /api/v1/billing and billing.controller.ts
 * Permissions: billing.requests.view, billing.requests.request, billing.requests.respond
 */

/**
 * GET /api/v1/billing/requests
 * @param {{ page?: number, limit?: number, projectId?: string, auditId?: string }} params
 */
export const getBillingRequests = (params = {}) =>
    http.get('/billing/requests', { params }).then((res) => {
        const payload = res.data?.data ?? res.data;
        return {
            data: payload?.data ?? payload?.items ?? [],
            total: payload?.total ?? 0,
            page: payload?.page ?? 1,
            limit: payload?.limit ?? 10,
            totalPages: payload?.totalPages ?? 1,
        };
    });

/**
 * POST /api/v1/billing/projects/:projectId/request
 * @param {string} projectId
 * @param {{ projectPaymentId: string, milestoneSubmissionId?: string }} body
 */
export const createBillingRequestForProject = (projectId, body) =>
    http.post(`/billing/projects/${projectId}/request`, body).then((res) => res.data?.data ?? res.data);

/**
 * POST /api/v1/billing/audits/:auditId/request
 * @param {string} auditId
 * @param {{ projectAuditPaymentId: string, milestoneSubmissionId?: string }} body
 */
export const createBillingRequestForAudit = (auditId, body) =>
    http.post(`/billing/audits/${auditId}/request`, body).then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/billing/requests/:id/respond
 * @param {string} requestId
 * @param {{ action: 'accepted' | 'declined', note?: string, rating?: number }} body
 */
export const respondBillingRequest = (requestId, body) =>
    http.patch(`/billing/requests/${requestId}/respond`, body).then((res) => res.data?.data ?? res.data);
